import PropTypes from "prop-types";
import styles from "./styles/accordion.module.css";

export function Accordion({ title, children }) {
  return (
    <main className={styles.main}>
      <details className={styles.details}>
        <summary className={styles.summary}>{title}</summary>
        <div className={styles.content}>{children}</div>
      </details>
    </main>
  );
}

Accordion.propTypes = {};
